import React, { Component } from 'react';
import { Drawer } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import PersonalInformation from './PersonalInformation';
import CompanyInformation from './CompanyInformation';
import ManageUser from './ManageUsers';
import ManageAddress from './ManageAddress';
import ChangePassword from './ChangePassword';
import DiamondColumnListing from './ManageDiamondSequence';
import SavedSearch from '../SavedSearch/index';
import MyDemand from '../MyDemand/index';
import Offer from '../Offer';
import '../../components/common/Tab';
import DiamondList from '../../components/DiamondList/index';
import IntlMessages from '../../util/IntlMessages';
import NotificationSetting from './NotificationSetting';
import Profile from './Profile';
import { connect } from 'react-redux';
import { isMobile, getPath, LISTINGPAGES } from '../DiamondList/DiamondListFunctions';
import SelectStone from '../common/DiamondListing/SelectStone';
import UtilService from '../../services/util';
import { LOCAL_STORAGE_VAR, KYC_STATUS, trackTypeObj } from '../../constants/Common';

class Account extends Component {
  state = { visible: false, visible1: false, visible2: false, sum: {} };

  componentDidMount() {
    if (this.props.location.pathname.includes('/account')) {
      this.checkRoute();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.checkRoute();
    }
  }
  checkRoute = () => {
    let userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);
    if (this.props.location.pathname.includes('/account')) {
      if (userData && userData.account && userData.account.isApproved !== KYC_STATUS.APPROVED) {
        this.props.history.push('/account/profile');
        // KYC under process
      } else {
        // this.props.history.push('/account/watchlist')
      }
    }
  };
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };
  showDrawer1 = () => {
    this.setState({
      visible1: true,
    });
  };
  showDrawer2 = () => {
    this.setState({
      visible2: true,
    });
  };
  onClose = () => {
    this.setState({
      visible: false,
      visible1: false,
      visible2: false,
    });
  };

  render() {
    const { location } = this.props;
    let userData = UtilService.getLocalStorageItem(`${LOCAL_STORAGE_VAR}-user`);

    const profilePath = location.pathname === '/account/profile';
    const manageuserPath = location.pathname === '/account/profile/manage-user';
    const manageAddressPath = location.pathname === '/account/profile/manage-address';
    const diamondsequencePath = location.pathname === '/account/profile/diamond-sequence';
    const myProfile = location.pathname === '/account/profile';
    let TABS = [
      {
        path: '/watchlist',
        title: <IntlMessages id="app.my-watchlist" />,
        tab: (
          <DiamondList
            trackType={trackTypeObj.WATCHLIST}
            onSumChange={(sum, currentType) => this.setState({ sum, currentType })}
          />
        ),
      },
      {
        path: '/cart',
        title: <IntlMessages id="app.my-cart" />,
        tab: (
          <DiamondList
            trackType={trackTypeObj.CART}
            onSumChange={(sum, currentType) => this.setState({ sum, currentType })}
          />
        ),
      },
      {
        path: '/office-list',
        title: <IntlMessages id="app.MyOfficeView" />,
        tab: (
          <DiamondList
            officeView
            trackType={trackTypeObj.OFFICE}
            onSumChange={(sum, currentType) => this.setState({ sum, currentType })}
          />
        ),
      },
      {
        path: '/quote-list',
        title: <IntlMessages id="app.MyOfferList" />,
        tab: (
          <Offer
            trackType={trackTypeObj.QUOTE}
            onSumChange={(sum, currentType) => this.setState({ sum, currentType })}
          />
        ),
      },
      {
        path: '/confirm-list',
        title: <IntlMessages id="app.MyOrderedList" />,
        tab: <DiamondList order onSumChange={(sum, currentType) => this.setState({ sum, currentType })} />,
      },
      {
        path: '/my-purchase',
        title: <IntlMessages id="app.MyPurchaseHistory" />,
        tab: (
          <DiamondList noDetailAction order onSumChange={(sum, currentType) => this.setState({ sum, currentType })} />
        ),
      },
      {
        path: '/saved-search',
        title: <IntlMessages id="app.saved-search" />,
        tab: <SavedSearch />,
      },
      {
        path: '/my-demand',
        title: <IntlMessages id="app.my-demand-tab" />,
        tab: <MyDemand />,
      },
      // {
      //     path: '/notification',
      //     title: <>Notification</>,
      //     tab: <NotificationSetting />
      // }
    ];
    if (userData && userData.account && userData.account.isApproved !== KYC_STATUS.APPROVED) {
      TABS = [];
    }
    let isaccount = window.location.pathname.split('/')[1] === 'account';
    return (
      <div>
        <div className="accountWrapper">
          <div className="accountTopBlock">
            <div className="accountUser">
              <h2 className="accountTitle">
                <IntlMessages id="app.YourAccount" />
              </h2>
            </div>
            {isaccount && !isMobile() && getPath() !== LISTINGPAGES.CONFIRM ? (
              <SelectStone
                clearStyle={{ position: 'inherit', width: '67px', height: 'fit-content' }}
                blockStyle={{
                  position: 'initial',
                  borderBottom: 'none',
                  width: 'fit-content',
                  paddingRight: '0px',
                }}
                sum={this.state.sum}
                currentType={this.props.location.pathname}
                profilListing={isaccount ? 'profileStonSelect' : null}
              />
            ) : null}
            {/* <div className="accountLogout">
              <a>
                Sign Out{" "}
                <img
                  src={require("../../assets/svg/Header/right.svg")}
                  alt="icon"
                />
              </a>
            </div> */}
          </div>
          <div className="customerSubTab">
            <ul className="accountTabBox">
              {TABS.map((x) => {
                return (
                  <li className={location.pathname === '/account' + x.path ? 'react-tabs__tab--selected' : null}>
                    <Link to={'/account' + x.path}>{x.title}</Link>
                  </li>
                );
              })}
              <li
                className={`${
                  manageuserPath || manageAddressPath || diamondsequencePath || profilePath
                    ? 'react-tabs__tab--selected'
                    : ''
                }`}
              >
                <Link to="/account/profile">Personal Details</Link>
              </li>
            </ul>
            {TABS.map((x) => {
              return location.pathname === '/account' + x.path ? <>{x.tab}</> : <></>;
            })}
            {myProfile && <Profile />}
            <Drawer
              title={false}
              onClose={this.onClose}
              visible={this.state.visible}
              wrapClassName="diamondListinSidebar profileSidebar"
            >
              <PersonalInformation />
            </Drawer>
            <Drawer
              title={false}
              onClose={this.onClose}
              visible={this.state.visible1}
              wrapClassName="diamondListinSidebar profileSidebar"
            >
              <CompanyInformation />
            </Drawer>
            {manageuserPath && <ManageUser />}
            <Drawer
              title={false}
              onClose={this.onClose}
              visible={this.state.visible2}
              wrapClassName="diamondListinSidebar profileSidebar"
            >
              <ChangePassword />
            </Drawer>
            {manageAddressPath && <ManageAddress />}
            {diamondsequencePath && <DiamondColumnListing />}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((props) => {
  return { commonData: props.commonData };
}, {})(withRouter(Account));
